angular.module('core')
  .service('iaplApi', ['transformResponse', 'cancelableResourceFactory', '$state', '$templateCache', function($transformResponse, $cancelableResourceFactory, $state, $templateCache) {

    var self = this;

    var accessIdMapping = function(body) {
      try {
        var accessId = JSON.parse(body);
        accessId.type = 'accessId';
        return accessId;
      } catch (e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var pdProgressMapping = function(body) {
      try {
        var progresses = JSON.parse(body);
        if (!progresses.data) {
          console.error('Transform Progress Error: data node is missing.');
          progresses.data = {};
        }
        progresses.type = 'pdProgress';
        return progresses;
      } catch (e) {
        console.error('Transform Progress Error:', e.message);
        return {data: {}};
      }
    };

    var pdContentMapping = function(body) {
      try {
        var pdContents = JSON.parse(body);
        pdContents.type = 'pdContent';
        return pdContents;
      } catch (e) {
        console.error('Transform PD Content Error:', e.message);
        return {data: {}};
      }
    };

    var getAccessId = $cancelableResourceFactory.createCacheableResource(null, '/x/accessIds', {
     timestamp: '@timestamp'
    }, {
      get: {
        cache: false, // cannot reuse any cached ones!!
        transformResponse: accessIdMapping,
        url: '/x/accessIds?timestamp=:timestamp',
        method: 'GET'
      }
    });

    var pdLocationsUrl = '/x/district/:districtId/pd-locations?keys=:keys';
    var getPdLocations = $cancelableResourceFactory.createCacheableResource(null, pdLocationsUrl, {
         districtId: '@districtId',
         keys: '@keys'
    }, {
      get: {
        cache: true,
        transformResponse: $transformResponse.transformResponseToJson,
        url: pdLocationsUrl,
        method: 'GET'
      }
    });

    var getPdProgress = $cancelableResourceFactory.createCacheableResource(null, '/x/pd-progresses', {
      sy: '@sy',
      days: '@days',
      fd: '@fd',
      td: '@td'
    }, {
      get: {
        transformResponse: pdProgressMapping,
        url: '/x/pd-progresses?sy=:sy&days=:days&fd=:fd&td=:td',
        method: 'GET'
      }
    });

    var pdContentsUrl = '/x/district/:districtId/pd-contents';
    var getPdContents = $cancelableResourceFactory.createCacheableResource(null, pdContentsUrl, {
         districtId: '@districtId'
    }, {
      get: {
        transformResponse: pdContentMapping,
        url: pdContentsUrl,
        method: 'GET'
      }
    });

    var lessonGroupsUrl = '/x/lesson-groups';
    var getLessonGroups = $cancelableResourceFactory.createCacheableResource(null, lessonGroupsUrl, {
    }, {
      get: {
        cache: true,
        transformResponse: $transformResponse.transformResponseToJson,
        url: lessonGroupsUrl,
        method: 'GET'
      }
    });

    /**************************************************************/
    /*                          Api                               */
    /**************************************************************/
    // getAccessId
    self.getAccessId = function(/*userId, */ success, error) {
      var promise = getAccessId.get({
         timestamp: Date.now() // cache busting parameter for IE
        // id: userId
      });

      promise.$promise.then(function(accessIdResponse) {
        success(accessIdResponse);
      });
      return promise;
    };

    // getPDLocations
    self.getPdLocations = function(keys, success, error) {
      var params = _.pick($state.params, ['districtId']);
      params.keys = keys;
      var promise = getPdLocations.get(params);

      if (success !== undefined) {
        promise.$promise.then(function(locationMap) {
          success(locationMap);
        });
      }
      return promise;
    };

    // getPdProgress
    self.getPdProgress = function(sy, days, fd, td) {
      var promise = getPdProgress.get({
        sy: sy,
        days: days,
        fd: fd,
        td: td
      });
      return promise;
    };

    // getPDContents
    self.getPdContents = function() {
      var params = _.pick($state.params, ['districtId']);
      var promise = getPdContents.get(params);
      return promise;
    };

    // getLessonGroups
    self.getLessonGroups = function() {
      var promise = getLessonGroups.get();
      return promise;
    };

  }]);
